<template>
  <v-card class="matriz-card" elevation="0">
    <div class="matriz-header">
      <div class="matriz-title-block">
        <div class="matriz-icon-wrap">
          <v-icon color="#1f6feb" size="22">mdi-view-grid-outline</v-icon>
        </div>
        <div>
          <h3 class="matriz-title">Matriz de Producción por Máquina</h3>
          <p class="matriz-subtitle">Comparativo por día, turno y métrica productiva</p>
        </div>
      </div>

      <div class="matriz-summary">
        <span class="summary-pill">
          <v-icon size="14" color="#5a6476">mdi-factory</v-icon>
          {{ maquinas.length }} máquinas
        </span>
        <span class="summary-pill">
          <v-icon size="14" color="#5a6476">mdi-calendar-range</v-icon>
          {{ GetGruposDia().length }} días
        </span>
      </div>
    </div>

    <v-card-text class="pa-0">
      <div class="scroll-x">
        <v-simple-table dense class="matriz-table">
          <thead>
            <tr>
              <th class="sticky-top machine-column head-main">
                <v-icon size="14" color="#5a6476">mdi-factory</v-icon>
                Máquina
              </th>
              <th class="sticky-top day-column">Día</th>
              <th class="sticky-top turn-column">Turno</th>
              <th class="sticky-top text-center">Inicio</th>
              <th class="sticky-top text-center">Fin</th>
              <th class="sticky-top text-center">Piezas Esperadas</th>
              <th class="sticky-top text-center">Piezas Reales</th>
              <th class="sticky-top text-center">Tiempo Trabajado</th>
              <th class="sticky-top text-center">Tiempo Paro NP</th>
              <th class="sticky-top text-center">Disponibilidad</th>
              <th class="sticky-top text-center">Eficiencia</th>
              <th class="sticky-top text-center">Operadores Logueados</th>
            </tr>
          </thead>

          <tbody>
            <template v-for="row in GetFilasDia()">
              <tr :key="row.key" class="day-row" :class="{ 'machine-start': row.mostrarMaquina }">
                <td class="machine-cell">
                  <div class="machine-name">
                    <v-icon size="15" color="#1f6feb">mdi-cog-outline</v-icon>
                    <span>{{ row.maquinaNombre }}</span>
                  </div>
                </td>

                <td class="day-cell">
                  <div class="day-label day-label--row">
                    <span class="day-week">{{ DiaParts(row.diaLabel).weekday }}</span>
                    <span class="day-date">{{ DiaParts(row.diaLabel).date }}</span>
                  </div>
                </td>

                <td class="turn-cell">
                  <span class="shift-pill">{{ row.turnoLabel }}</span>
                </td>

                <td class="value-cell">
                  <span class="value-pill">{{ FormatearFechaSinT(row.inicio) }}</span>
                </td>
                <td class="value-cell">
                  <span class="value-pill">{{ FormatearFechaSinT(row.fin) }}</span>
                </td>
                <td class="value-cell">
                  <span class="value-pill">{{ FormatearValor(row.piezasEsperadas, 'int') }}</span>
                </td>
                <td class="value-cell">
                  <span class="value-pill">{{ FormatearValor(row.piezasReales, 'int') }}</span>
                </td>
                <td class="value-cell">
                  <span class="value-pill">{{ FormatearValor(row.horas, 'horas') }}</span>
                </td>
                <td class="value-cell">
                  <span class="value-pill">{{ FormatearValor(row.tiempoParoNoProgramadoSegundos, 'segundos') }}</span>
                </td>
                <td class="value-cell" :class="ValorClase(row.productividad, 'pct')">
                  <span class="value-pill">{{ FormatearValor(row.productividad, 'pct') }}</span>
                </td>
                <td class="value-cell" :class="ValorClase(row.eficiencia, 'pct')">
                  <span class="value-pill">{{ FormatearValor(row.eficiencia, 'pct') }}</span>
                </td>
                <td class="value-cell">
                  <span class="value-pill">{{ FormatearValor(row.operadoresReales, 'decimal') }}</span>
                </td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "MatrizProduccionPorMaquina",

  props: {
    // TU JSON, tal cual
    maquinas: { type: Array, default: () => [] },
  },

  data() {
    return {
      incluirTotalDia: true,

      metricas: [
        { key: "horas", label: "Tiempo Trabajado", tipo: "horas" },
        { key: "tiempoParoNoProgramadoSegundos", label: "Tiempo Paro NP", tipo: "segundos" },
        { key: "productividad", label: "Disponibilidad", tipo: "pct" },
        { key: "eficiencia", label: "Eficiencia", tipo: "pct" },
      ],

      gruposDia: [],
      columnas: [],
      filasRender: [],
      filasDia: [],

      _lastSig: "",
      _building: false,
    };
  },

  methods: {
    // ====== Getters para template (sin computed) ======
    GetGruposDia() {
      this.EnsureCache();
      return this.gruposDia || [];
    },

    GetColumnas() {
      this.EnsureCache();
      return this.columnas || [];
    },

    GetFilasRender() {
      this.EnsureCache();
      return this.filasRender || [];
    },

    GetFilasDia() {
      this.EnsureCache();
      return this.filasDia || [];
    },

    EnsureCache() {
      if (this._building) return;

      const sig = this.FirmaMaquinas(this.maquinas);
      if (sig === this._lastSig) return;

      this._lastSig = sig;

      this._building = true;
      try {
        this.RebuildCache(this.maquinas);
      } finally {
        this._building = false;
      }
    },

    FirmaMaquinas(maquinas) {
      const arr = Array.isArray(maquinas) ? maquinas : [];
      const n = arr.length;
      if (n === 0) return "M:0";

      const firstId = arr[0]?.idMaquinaIns ?? "";
      const lastId = arr[n - 1]?.idMaquinaIns ?? "";
      const firstProductividad = this.NumeroCampo(arr[0], ['disponibilidad', 'Disponibilidad']) ?? "";
      const firstOperadores = this.NumeroCampo(arr[0], ['operadoresReales', 'OperadoresReales']) ?? "";
      const lastProductividad = this.NumeroCampo(arr[n - 1], ['disponibilidad', 'Disponibilidad']) ?? "";
      const lastOperadores = this.NumeroCampo(arr[n - 1], ['operadoresReales', 'OperadoresReales']) ?? "";

      let countRangos = 0;
      let sumSample = 0;

      for (let i = 0; i < Math.min(3, n); i += 1) {
        const r = this.ObtenerRangosMaquina(arr[i]);
        countRangos += r.length;

        for (let k = 0; k < Math.min(5, r.length); k += 1) {
          sumSample += Number(r[k]?.esperadasReales ?? 0);
          sumSample += Number(r[k]?.hechasReales ?? 0);
          sumSample += Number(r[k]?.disponibilidad ?? r[k]?.Disponibilidad ?? 0);
          sumSample += Number(r[k]?.eficiencia ?? r[k]?.Eficiencia ?? 0);
          sumSample += Number(r[k]?.tiempoParoNoProgramadoSegundos ?? r[k]?.TiempoParoNoProgramadoSegundos ?? 0);
          sumSample += Number(r[k]?.tiempoTrabajadoSegundos ?? r[k]?.TiempoTrabajadoSegundos ?? 0);
        }
      }

      return `M:${n}:${firstId}:${lastId}:${firstProductividad}:${firstOperadores}:${lastProductividad}:${lastOperadores}:${countRangos}:${sumSample}`;
    },

    // ====== Construcción dinámica a partir de TU JSON ======
    RebuildCache(maquinas) {
      const maquinasArr = Array.isArray(maquinas) ? maquinas : [];

      // 1) Días y turnos detectados por "inicio"
      const diasMap = {}; // { [YYYY-MM-DD]: { key,label, turnosInfo:{[idTurno]:{inicioTime, cruza}} } }

      for (let mi = 0; mi < maquinasArr.length; mi += 1) {
        const rangos = this.ObtenerRangosMaquina(maquinasArr[mi]);
        for (let ri = 0; ri < rangos.length; ri += 1) {
          const r = rangos[ri];
          const inicio = String(r?.inicio || "");
          const fin = String(r?.fin || "");
          const dia = inicio.slice(0, 10);
          if (!dia) continue;

          if (!diasMap[dia]) {
            diasMap[dia] = { key: dia, label: this.LabelDia(dia), turnosInfo: {} };
          }

          const idTurno = r?.idTurno;
          if (!idTurno) continue;

          if (!diasMap[dia].turnosInfo[idTurno]) {
            const inicioTime = (inicio.split("T")[1] || "00:00:00");
            const cruza = inicio.slice(0, 10) !== fin.slice(0, 10);

            const turno = String(r?.turno || "").trim(); // <- NUEVO

            diasMap[dia].turnosInfo[idTurno] = {
              inicioTime,
              cruza,
              turno: turno || `T${idTurno}`, // <- NUEVO
            };
          }
        }
      }

      const dias = Object.values(diasMap);
      dias.sort((a, b) => String(a.key).localeCompare(String(b.key)));

      // 2) Grupos/Columnas (encabezado día + turnos)
      const grupos = [];
      const columnas = [];

      for (let di = 0; di < dias.length; di += 1) {
        const d = dias[di];

        const turnos = Object.keys(d.turnosInfo)
          .map(x => Number(x))
          .filter(x => !Number.isNaN(x));

        turnos.sort((a, b) => {
          const ta = d.turnosInfo[a]?.inicioTime || "00:00:00";
          const tb = d.turnosInfo[b]?.inicioTime || "00:00:00";
          return ta.localeCompare(tb);
        });

        const colsDia = [];
        if (this.incluirTotalDia) {
          colsDia.push({ key: `${d.key}|TOTAL`, label: "Día", isTotal: true });
        }

        for (let ti = 0; ti < turnos.length; ti += 1) {
          const idTurno = turnos[ti];
          const nombreTurno = d.turnosInfo[idTurno]?.turno || `T${idTurno}`; // <- AQUÍ

          colsDia.push({
            key: `${d.key}|${idTurno}`,
            label: nombreTurno,
            isTotal: false,
            idTurno,
            diaKey: d.key,
          });
        }

        grupos.push({ key: d.key, label: d.label, columnas: colsDia });

        for (let ci = 0; ci < colsDia.length; ci += 1) columnas.push(colsDia[ci]);
      }

      // 3) Index por máquina/día/turno desde TU JSON
      const idxMaquinas = [];
      for (let mi = 0; mi < maquinasArr.length; mi += 1) {
        const m = maquinasArr[mi];
        const id = m?.idMaquinaIns;
        if (!id) continue;

        const entry = {
          idMaquinaIns: id,
          nombre: this.NombreMaquina(m),
          operadoresReales: this.NumeroCampo(m, ['operadoresReales', 'OperadoresReales']),
          porDia: {},
        };

        const rangos = this.ObtenerRangosMaquina(m);
        for (let ri = 0; ri < rangos.length; ri += 1) {
          const r = rangos[ri];
          const inicio = String(r?.inicio || "");
          const fin = String(r?.fin || "");
          const dia = inicio.slice(0, 10);
          const idTurno = r?.idTurno;

          if (!dia || !idTurno) continue;
          if (!entry.porDia[dia]) entry.porDia[dia] = {};

          const planeadas = Number(r?.esperadasReales ?? 0);
          const hechas = Number(r?.hechasReales ?? 0);

          const horas = this.HorasTrabajadasRango(r, inicio, fin, planeadas, hechas);
          const productividad = this.NumeroCampo(r, ['disponibilidad', 'Disponibilidad']);
          const tiempoParoNoProgramadoSegundos = this.NumeroCampo(r, ['tiempoParoNoProgramadoSegundos', 'TiempoParoNoProgramadoSegundos']);
          const operadoresReales = this.NumeroCampo(r, ['operadoresReales', 'OperadoresReales']);

          if (!entry.porDia[dia][idTurno]) {
            entry.porDia[dia][idTurno] = {
              inicio: '',
              fin: '',
              horas: 0,
              piezasEsperadas: 0,
              piezasReales: 0,
              productividad: null,
              eficiencia: null,
              tiempoParoNoProgramadoSegundos: 0,
              operadoresReales: null,
              muestrasProductividad: [],
              muestrasEficiencia: [],
            };
          }

          const acumulado = entry.porDia[dia][idTurno];
          if (!acumulado.inicio || String(inicio).localeCompare(String(acumulado.inicio)) < 0) acumulado.inicio = inicio;
          if (!acumulado.fin || String(fin).localeCompare(String(acumulado.fin)) > 0) acumulado.fin = fin;
          acumulado.horas += horas;
          acumulado.piezasEsperadas += planeadas;
          acumulado.piezasReales += hechas;
          acumulado.tiempoParoNoProgramadoSegundos += Math.max(0, tiempoParoNoProgramadoSegundos || 0);
          if (productividad !== null) acumulado.muestrasProductividad.push(productividad);
          const eficiencia = this.NumeroCampo(r, ['eficiencia', 'Eficiencia']);
          if (eficiencia !== null) acumulado.muestrasEficiencia.push(eficiencia);
          if (operadoresReales !== null) acumulado.operadoresReales = operadoresReales;
        }

        idxMaquinas.push(entry);
      }

      idxMaquinas.sort((a, b) => String(a.nombre || "").localeCompare(String(b.nombre || "")));

      // 4) Filas
      const filas = [];
      const filasDia = [];
      for (let mi = 0; mi < idxMaquinas.length; mi += 1) {
        const m = idxMaquinas[mi];
        let primeraFilaMaquina = true;

        for (let g = 0; g < grupos.length; g += 1) {
          const grupo = grupos[g];
          const columnasTurno = grupo.columnas.filter(col => !col.isTotal);

          for (let c = 0; c < columnasTurno.length; c += 1) {
            const col = columnasTurno[c];
            const det = this.DetalleMaquinaDiaTurno(m, col.diaKey, col.idTurno);

            if (!this.TieneDatosTurno(det)) continue;

            filasDia.push({
              key: `${m.idMaquinaIns}-${col.key}`,
              maquinaNombre: m.nombre,
              mostrarMaquina: primeraFilaMaquina,
              diaKey: grupo.key,
              diaLabel: grupo.label,
              turnoLabel: col.label,
              inicio: det.inicio,
              fin: det.fin,
              piezasEsperadas: det.piezasEsperadas,
              piezasReales: det.piezasReales,
              horas: this.ValorPorMetrica(det, "horas"),
              tiempoParoNoProgramadoSegundos: det.tiempoParoNoProgramadoSegundos,
              productividad: this.ValorPorMetrica(det, "productividad"),
              eficiencia: this.ValorPorMetrica(det, "eficiencia"),
              operadoresReales: det.operadoresReales ?? m.operadoresReales,
            });

            primeraFilaMaquina = false;
          }
        }

        for (let k = 0; k < this.metricas.length; k += 1) {
          const met = this.metricas[k];
          const valores = {};

          for (let g = 0; g < grupos.length; g += 1) {
            const diaKey = grupos[g].key;

            for (let c = 0; c < grupos[g].columnas.length; c += 1) {
              const col = grupos[g].columnas[c];

              if (col.isTotal) {
                const tot = this.TotalesMaquinaDia(m, diaKey);
                valores[col.key] = this.ValorPorMetrica(tot, met.key);
              } else {
                const det = this.DetalleMaquinaDiaTurno(m, col.diaKey, col.idTurno);
                valores[col.key] = this.ValorPorMetrica(det, met.key);
              }
            }
          }

          filas.push({
            key: `${m.idMaquinaIns}-${met.key}`,
            maquinaNombre: m.nombre,
            mostrarMaquina: k === 0,
            rowspan: this.metricas.length,
            metricaLabel: met.label,
            tipo: met.tipo,
            valoresPorColumna: valores,
          });
        }
      }

      // SETS (sin _cache)
      this.gruposDia = grupos;
      this.columnas = columnas;
      this.filasRender = filas;
      this.filasDia = filasDia;
    },

    // ===== Helpers =====
    ObtenerRangosMaquina(maquina) {
      const rangosDirectos = Array.isArray(maquina?.esperadasPorRango) ? maquina.esperadasPorRango : [];
      const turnos = Array.isArray(maquina?.turnos) ? maquina.turnos : [];

      if (!turnos.length) return rangosDirectos;

      const rangosTurnos = [];
      for (let ti = 0; ti < turnos.length; ti += 1) {
        const turno = turnos[ti] || {};
        const rangos = Array.isArray(turno.rangos) ? turno.rangos : [];

        if (!rangos.length) {
          rangosTurnos.push(turno);
          continue;
        }

        for (let ri = 0; ri < rangos.length; ri += 1) {
          rangosTurnos.push({
            ...turno,
            ...rangos[ri],
            idTurno: rangos[ri]?.idTurno ?? turno.idTurno,
            turno: rangos[ri]?.turno || turno.turno,
          });
        }
      }

      return rangosTurnos.length ? rangosTurnos : rangosDirectos;
    },

    TieneDatosTurno(detalle) {
      if (!detalle) return false;
      return (
        Number(detalle.horas || 0) > 0 ||
        Number(detalle.piezasEsperadas || 0) > 0 ||
        Number(detalle.piezasReales || 0) > 0 ||
        Number(detalle.tiempoParoNoProgramadoSegundos || 0) > 0 ||
        Number(detalle.operadoresReales || 0) > 0
      );
    },

    LabelDia(fechaYYYYMMDD) {
      const f = String(fechaYYYYMMDD || "").trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(f)) return f || "Día";
      const d = new Date(`${f}T00:00:00`);
      const wd = d.toLocaleDateString("es-MX", { weekday: "long" });
      return `[${wd}] ${f}`;
    },

    NombreMaquina(m) {
      const n = String(m?.nombre || "").trim();
      const mod = String(m?.modelo || "").trim();
      if (n && mod) return `[${n}] - ${mod}`;
      return n || mod || `Máquina ${m?.idMaquinaIns ?? ""}`;
    },

    DuracionHoras(inicioIso, finIso) {
      const a = Date.parse(inicioIso);
      const b = Date.parse(finIso);
      if (!Number.isNaN(a) && !Number.isNaN(b)) {
        const h = (b - a) / 3600000;
        return h > 0 ? h : 0;
      }
      return 0;
    },

    HorasTrabajadasRango(rango, inicioIso, finIso, planeadas, hechas) {
      const segundos = this.NumeroCampo(rango, ['tiempoTrabajadoSegundos', 'TiempoTrabajadoSegundos']);
      if (segundos !== null) return Math.max(0, segundos / 3600);

      return (planeadas > 0 || hechas > 0) ? this.DuracionHoras(inicioIso, finIso) : 0;
    },

    NumeroCampo(item, campos) {
      const campo = campos.find(nombre => item?.[nombre] !== null && item?.[nombre] !== undefined && item?.[nombre] !== '');
      if (!campo) return null;

      const numero = Number(item[campo]);
      return Number.isFinite(numero) ? numero : null;
    },

    DetalleMaquinaDiaTurno(m, diaKey, idTurno) {
      const det = m?.porDia?.[diaKey]?.[idTurno] || null;
      return det || { inicio: '', fin: '', horas: 0, piezasEsperadas: 0, piezasReales: 0, tiempoParoNoProgramadoSegundos: 0, muestrasEficiencia: [] };
    },

    TotalesMaquinaDia(m, diaKey) {
      const mapa = m?.porDia?.[diaKey] || {};
      const turnos = Object.values(mapa);

      let horas = 0;
      let piezasEsperadas = 0;
      let piezasReales = 0;
      let tiempoParoNoProgramadoSegundos = 0;

      for (let i = 0; i < turnos.length; i += 1) {
        horas += Number(turnos[i]?.horas ?? 0);
        piezasEsperadas += Number(turnos[i]?.piezasEsperadas ?? 0);
        piezasReales += Number(turnos[i]?.piezasReales ?? 0);
        tiempoParoNoProgramadoSegundos += Number(turnos[i]?.tiempoParoNoProgramadoSegundos ?? 0);
      }

      return { horas, piezasEsperadas, piezasReales, tiempoParoNoProgramadoSegundos };
    },

    ValorPorMetrica(obj, key) {
      const horas = Number(obj?.horas ?? 0);
      const piezasEsperadas = Number(obj?.piezasEsperadas ?? 0);
      const piezasReales = Number(obj?.piezasReales ?? 0);

      if (key === "horas") return horas;
      if (key === "planeadas" || key === "piezasEsperadas") return piezasEsperadas;
      if (key === "hechas" || key === "piezasReales") return piezasReales;
      if (key === "tiempoParoNoProgramadoSegundos") return Number(obj?.tiempoParoNoProgramadoSegundos ?? 0);
      if (key === "productividad") {
        const muestras = Array.isArray(obj?.muestrasProductividad) ? obj.muestrasProductividad : [];
        if (muestras.length) {
          return muestras.reduce((total, valor) => total + Number(valor || 0), 0) / muestras.length;
        }

        const productividad = Number(obj?.productividad);
        return Number.isFinite(productividad) ? productividad : 0;
      }
      if (key === "eficiencia") {
        const muestras = Array.isArray(obj?.muestrasEficiencia) ? obj.muestrasEficiencia : [];
        if (muestras.length) {
          return muestras.reduce((total, valor) => total + Number(valor || 0), 0) / muestras.length;
        }

        const eficiencia = Number(obj?.eficiencia);
        return Number.isFinite(eficiencia) ? eficiencia : 0;
      }
      return 0;
    },

    FormatearValor(val, tipo) {
      const n = Number(val ?? 0);
      if (tipo === "pct") return `${n.toFixed(2)} %`;
      if (tipo === "horas") return this.FormatearHorasHHmm(n);
      if (tipo === "segundos") return this.FormatearSegundosHHmmss(n);
      if (tipo === "int") return n.toLocaleString("es-MX");
      if (tipo === "decimal") return this.FormatearDecimalFlexible(val);
      return String(val ?? "0");
    },

    FormatearFechaSinT(fecha) {
      if (!fecha) return '';
      return String(fecha).replace('T', ' ');
    },

    FormatearDecimalFlexible(valor) {
      if (valor === null || valor === undefined || valor === '') return '';
      const n = Number(valor);
      if (!Number.isFinite(n)) return '';
      return Number.isInteger(n)
        ? n.toLocaleString("es-MX")
        : n.toLocaleString("es-MX", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },

    FormatearHorasHHmm(horas) {
      const totalMinutos = Math.max(0, Math.floor((Number(horas) || 0) * 60));
      const h = Math.floor(totalMinutos / 60);
      const m = totalMinutos % 60;
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    },

    FormatearSegundosHHmmss(segundos) {
      const totalSegundos = Math.max(0, Math.floor(Number(segundos) || 0));
      const h = Math.floor(totalSegundos / 3600);
      const m = Math.floor((totalSegundos % 3600) / 60);
      const s = totalSegundos % 60;
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    },

    DiaParts(label) {
      const texto = String(label || "");
      const match = texto.match(/^\[(.+?)\]\s*(.+)$/);
      return {
        weekday: match ? match[1] : "Día",
        date: match ? match[2] : texto,
      };
    },

    ValorClase(val, tipo) {
      const n = Number(val ?? 0);
      if (tipo === "pct") {
        if (n >= 85) return "value-good";
        if (n >= 60) return "value-warn";
        if (n > 0) return "value-bad";
        return "value-empty";
      }
      if (n <= 0) return "value-empty";
      return "";
    },
  },
};
</script>

<style scoped>
.matriz-card {
  border: 1px solid #e6eaf0;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
}

.matriz-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 18px;
  border-bottom: 1px solid #e6eaf0;
  background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
}

.matriz-title-block {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.matriz-icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eaf2ff;
  border: 1px solid #d8e7ff;
  flex-shrink: 0;
}

.matriz-title {
  margin: 0;
  color: #172033;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.2;
}

.matriz-subtitle {
  margin: 3px 0 0;
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
}

.matriz-summary {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.summary-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 10px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #394458;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.scroll-x {
  overflow-x: auto;
  background: #f8fafc;
  scrollbar-color: #9aa4b2 #edf2f7;
}

.scroll-x::-webkit-scrollbar {
  height: 10px;
}

.scroll-x::-webkit-scrollbar-track {
  background: #edf2f7;
}

.scroll-x::-webkit-scrollbar-thumb {
  background: #9aa4b2;
  border-radius: 999px;
  border: 2px solid #edf2f7;
}

.matriz-table {
  background: #ffffff;
  border-collapse: separate;
  border-spacing: 0;
}

.matriz-table th,
.matriz-table td {
  white-space: nowrap;
  border-bottom: 1px solid #e6eaf0 !important;
  font-size: 12px;
}

.matriz-table th {
  height: 44px;
  color: #475569;
  font-weight: 800;
  letter-spacing: 0;
  background: #ffffff;
}

.matriz-table td {
  height: 34px;
  color: #172033;
  text-align: center;
}

.head-main {
  text-align: left;
  vertical-align: middle;
  box-shadow: 8px 0 18px rgba(15, 23, 42, 0.05);
}

.head-main .v-icon {
  margin-right: 5px;
}

.sticky-top {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 5;
}

.machine-column {
  min-width: 300px;
  max-width: 300px;
}

.sticky-left-2 {
  position: sticky;
  left: 310px;
  min-width: 170px;
  max-width: 170px;
  background: #fff;
  z-index: 8;
}

.day-header {
  background: #f1f6ff !important;
  border-left: 1px solid #dbe8ff;
  border-bottom: 1px solid #d8e7ff !important;
  z-index: 5;
}

.shift-header {
  top: 44px;
  background: #ffffff !important;
  z-index: 5;
}

.total-head {
  background: #f8fbff !important;
}

.day-label {
  display: inline-flex;
  align-items: baseline;
  justify-content: center;
  gap: 7px;
  padding: 5px 10px;
  border-radius: 8px;
}

.day-label--row {
  justify-content: flex-start;
  padding: 0;
}

.day-week {
  color: #1f6feb;
  font-size: 12px;
  font-weight: 800;
  text-transform: capitalize;
}

.day-date {
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.shift-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 82px;
  min-height: 24px;
  padding: 4px 9px;
  border-radius: 8px;
  background: #f4f6f9;
  color: #475569;
  font-size: 11px;
  font-weight: 800;
}

.total-shift {
  background: #eaf2ff;
  color: #1f6feb;
}

.day-row:nth-child(odd) td {
  background: #fbfcfe;
}

.day-row:hover td {
  background: #f5f9ff !important;
}

.machine-start td {
  border-top: 2px solid #dbe8ff !important;
}

.machine-cell {
  vertical-align: middle;
  border-right: 1px solid #e6eaf0;
  min-width: 300px;
  max-width: 300px;
}

.machine-name {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #172033;
  font-weight: 800;
  overflow: hidden;
}

.machine-name span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.metric-cell {
  color: #334155;
  font-weight: 800;
  border-right: 1px solid #e6eaf0;
}

.metric-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-right: 7px;
  vertical-align: middle;
  background: #94a3b8;
}

.metric-dot--horas { background: #1f6feb; }
.metric-dot--int { background: #16a34a; }
.metric-dot--pct { background: #f59e0b; }

.value-cell {
  min-width: 112px;
  background: #ffffff;
  text-align: center;
}

.day-column {
  min-width: 170px;
}

.day-cell {
  min-width: 170px;
  color: #334155;
  font-weight: 800;
  text-align: center;
}

.turn-column,
.turn-cell {
  min-width: 130px;
  text-align: center;
}

.total-cell {
  background: #f8fbff !important;
  border-left: 1px solid #dbe8ff;
  border-right: 1px solid #dbe8ff;
  font-weight: 800;
}

.value-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  padding: 3px 8px;
  border-radius: 7px;
  color: #172033;
  font-variant-numeric: tabular-nums;
}

.value-good .value-pill {
  background: #e7f6ee;
  color: #137348;
  font-weight: 800;
}

.value-warn .value-pill {
  background: #fff4dc;
  color: #9a6700;
  font-weight: 800;
}

.value-bad .value-pill {
  background: #fdeceb;
  color: #b42318;
  font-weight: 800;
}

.value-empty .value-pill {
  color: #94a3b8;
}

@media (max-width: 960px) {
  .matriz-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .matriz-summary {
    justify-content: flex-start;
  }

  .machine-column,
  .machine-cell {
    min-width: 230px;
    max-width: 230px;
  }

  .sticky-left-2 {
    left: 230px;
    min-width: 150px;
    max-width: 150px;
  }

  .turn-column,
  .turn-cell {
    min-width: 120px;
  }
}
</style>
